/* Meranie konverzií – GA4 + Google Ads + Meta Pixel.
   Spúšťa sa VÝHRADNE po súhlase s cookies (GDPR). Bez súhlasu je no-op.
   Identifikátory sa doplnia cez premenné prostredia vo frontend/.env:
     REACT_APP_GA4_ID                  napr. G-XXXXXXX
     REACT_APP_GOOGLE_ADS_ID           napr. AW-123456789
     REACT_APP_GOOGLE_ADS_SIGNUP_LABEL napr. AbCdEfGhIj (label konverzie "registrácia")
     REACT_APP_META_PIXEL_ID           napr. 123456789012345
   Pokiaľ sú prázdne, meranie je vypnuté (nevloží sa žiadny skript). */

const GA4_ID = process.env.REACT_APP_GA4_ID || "";
const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID || "";
const ADS_SIGNUP_LABEL = process.env.REACT_APP_GOOGLE_ADS_SIGNUP_LABEL || "";
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";

const CONSENT_KEY = "cookie_consent";
const ATTR_KEY = "apis_attribution";

let loaded = false;

export function hasConsent() {
  try { return localStorage.getItem(CONSENT_KEY) === "accepted"; } catch { return false; }
}

// Zachytí UTM / gclid / fbclid z URL pri prvom príchode a uloží ich pre atribúciu registrácie.
export function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid"];
    const found = {};
    keys.forEach((k) => { const v = params.get(k); if (v) found[k] = v; });
    if (Object.keys(found).length && !localStorage.getItem(ATTR_KEY)) {
      found.landing_at = new Date().toISOString();
      localStorage.setItem(ATTR_KEY, JSON.stringify(found));
    }
  } catch (e) { console.debug("attribution capture skipped", e); }
}

function readAttribution() {
  try { return JSON.parse(localStorage.getItem(ATTR_KEY) || "{}"); } catch { return {}; }
}

function injectGtag() {
  if (window.gtag || (!GA4_ID && !ADS_ID)) return;
  const id = GA4_ID || ADS_ID;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  if (GA4_ID) window.gtag("config", GA4_ID);
  if (ADS_ID) window.gtag("config", ADS_ID);
}

function injectMetaPixel() {
  if (window.fbq || !META_PIXEL_ID) return;
  /* eslint-disable */
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", META_PIXEL_ID);
  window.fbq("track", "PageView");
}

export function loadAnalytics() {
  if (loaded || !hasConsent()) return;
  loaded = true;
  injectGtag();
  injectMetaPixel();
}

// Hlavná konverzia: dokončená registrácia skúšobnej verzie.
export function trackSignup() {
  if (!hasConsent()) return;
  loadAnalytics();
  const attribution = readAttribution();
  if (window.gtag) {
    window.gtag("event", "sign_up", { method: "email", ...attribution });
    if (ADS_ID && ADS_SIGNUP_LABEL) {
      window.gtag("event", "conversion", { send_to: `${ADS_ID}/${ADS_SIGNUP_LABEL}` });
    }
  }
  if (window.fbq) window.fbq("track", "CompleteRegistration");
}
